import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'renciNoData'
})
export class NoDataPipe implements PipeTransform {

  transform(value: any, message: string = '&lt;No Data&gt;'): any {
    return value ? value : `<small class="text-muted">${message}</small>`;
  }
}
